import styled from 'styled-components';

export const SeasonsSectionStyled = styled.div`
  margin-top: calc(var(--px) * 20);

  .seasons-cta {
    width: calc(var(--apx) * 187);
    margin-right: calc(var(--apx) * 20);

    span {
      font-size: calc(var(--apx) * 14);
    }
  }
`;
